const Notification = ({ notifications = [], role = "Trainee" }) => {
  const relevant = notifications.filter(
    (item) => item.role === role || item.role === "All"
  );

  return (
    <div className="notification-panel">
      <div className="notification-title">
        <h3>Placement Notifications</h3>
        <span className="badge">{relevant.length}</span>
      </div>
      {relevant.length === 0 && <p>No new notifications.</p>}
      <ul>
        {relevant.map((item) => (
          <li key={item.id}>
            <span>{item.message}</span>
            <small>{new Date(item.date).toLocaleDateString()}</small>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Notification;
